var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pill statusPill font-semibold text-base",class:("statusPill--" + _vm.status)},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }